export const PENDING_IMPLANT_LIST_REQUEST = 'PENDING_IMPLANT_LIST_REQUEST'
export const PENDING_IMPLANT_LIST_SUCCESS = 'PENDING_IMPLANT_LIST_SUCCESS'
export const PENDING_IMPLANT_LIST_FAIL = 'PENDING_IMPLANT_LIST_FAIL'

export const PENDING_IMPLANT_DETAILS_REQUEST = 'PENDING_IMPLANT_DETAILS_REQUEST'
export const PENDING_IMPLANT_DETAILS_SUCCESS = 'PENDING_IMPLANT_DETAILS_SUCCESS'
export const PENDING_IMPLANT_DETAILS_FAIL = 'PENDING_IMPLANT_DETAILS_FAIL'

export const PENDING_IMPLANT_DELETE_REQUEST = 'PENDING_IMPLANT_DELETE_REQUEST'
export const PENDING_IMPLANT_DELETE_SUCCESS = 'PENDING_IMPLANT_DELETE_SUCCESS'
export const PENDING_IMPLANT_DELETE_FAIL = 'PENDING_IMPLANT_DELETE_FAIL'

export const PENDING_IMPLANT_CREATE_REQUEST = 'PENDING_IMPLANT_CREATE_REQUEST'
export const PENDING_IMPLANT_CREATE_SUCCESS = 'PENDING_IMPLANT_CREATE_SUCCESS'
export const PENDING_IMPLANT_CREATE_FAIL = 'PENDING_IMPLANT_CREATE_FAIL'
export const PENDING_IMPLANT_CREATE_RESET = 'PENDING_IMPLANT_CREATE_RESET'

export const PENDING_IMPLANT_UPDATE_REQUEST = 'PENDING_IMPLANT_UPDATE_REQUEST'
export const PENDING_IMPLANT_UPDATE_SUCCESS = 'PENDING_IMPLANT_UPDATE_SUCCESS'
export const PENDING_IMPLANT_UPDATE_FAIL = 'PENDING_IMPLANT_UPDATE_FAIL'

export const PENDING_IMPLANT_APPROVE_REQUEST = 'PENDING_IMPLANT_APPROVE_REQUEST'
export const PENDING_IMPLANT_APPROVE_SUCCESS = 'PENDING_IMPLANT_APPROVE_SUCCESS'
export const PENDING_IMPLANT_APPROVE_FAIL = 'PENDING_IMPLANT_APPROVE_FAIL'

export const PENDING_IMPLANT_REJECT_REQUEST = 'PENDING_IMPLANT_REJECT_REQUEST'
export const PENDING_IMPLANT_REJECT_SUCCESS = 'PENDING_IMPLANT_REJECT_SUCCESS'
export const PENDING_IMPLANT_REJECT_FAIL = 'PENDING_IMPLANT_REJECT_FAIL'





